export default "__VITE_ASSET__CpmPzjkE__"